import { render, staticRenderFns } from "./RequirementDocumentTypeEdit.vue?vue&type=template&id=02851858"
import script from "./RequirementDocumentTypeEdit.vue?vue&type=script&lang=js"
export * from "./RequirementDocumentTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports